(() => {
  'use strict';
  if (window.OPNFabricWall) return;
  window.OPNFabricWall = true;
  const root = window.Shopify?.routes?.root || '/';
  const wallURL = root + 'pages/fabric-design-wall';
  if (new URLSearchParams(location.search).get('view') === 'fabric-wall' && location.pathname.includes('/collections/')) {
    const destination = new URL(wallURL, location.origin);
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) destination.searchParams.set('preview_theme_id', preview);
    location.replace(destination.href);
    return;
  }
  const KEY = 'opn-fabric-wall-v1';
  const sampleHandle = 'shannon-cuddle-minky-fabric-swatch-sample-get-up-to-5-swatches-for-6';
  const wall = document.querySelector('[data-opn-wall]');
  const board = wall?.querySelector('[data-opn-board]');
  const currency = window.Shopify?.currency?.active || 'USD';
  const money = n => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency,currencyDisplay:'code'}).format(n / 100);
  let items = [], cart = null, busy = false, loading = true, browseID = 0, addingHandle = null;
  const cache = new Map();
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const safeImage = src => { try { const u = new URL(src, location.href); return u.protocol === 'https:' ? u.href : ''; } catch { return ''; } };
  const getVariant = item => item.product?.variants.find(v => String(v.id) === String(item.variant));
  const lines = item => (cart?.items || []).filter(l => String(l.product_id) === String(item.product?.id));
  const simple = l => l.quantity === 1 && !l.selling_plan_allocation && !Object.keys(l.properties || {}).length && !l.parent_relationship;
  function status(message, error = false) {
    const el = wall?.querySelector('[data-opn-status]') || document.querySelector('[data-opn-toast]');
    if (el) { el.textContent = message; el.classList.toggle('opn-error', error); }
  }
  async function request(path, body) {
    const response = await fetch(path, {credentials:'same-origin', cache:'no-store', ...(body ? {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(body)} : {})});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Unable to complete the request. Please try again.');
    return data;
  }
  async function product(handle, fresh = false) {
    if (!fresh && cache.has(handle)) return cache.get(handle);
    const data = await request(root + 'products/' + encodeURIComponent(handle) + '.js');
    if (String(data.type).toLowerCase() !== 'minky' || !data.options?.some(o => /yard/i.test(typeof o === 'string' ? o : o.name))) throw new Error('This fabric is not available for yardage comparison.');
    cache.set(handle, data);
    return data;
  }
  function syncAddButtons() {
    document.querySelectorAll('[data-opn-add]').forEach(button => {
      const added = items.some(item => item.handle === button.dataset.opnAdd);
      const pending = addingHandle === button.dataset.opnAdd;
      const label = pending ? 'Adding…' : added ? '✓ Added to Fabric Wall' : 'Add to Fabric Wall';
      if (button.textContent !== label) button.textContent = label;
      button.classList.toggle('is-added', added);
      button.disabled = busy || loading;
      button.setAttribute('aria-busy', String(pending));
    });
  }
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(items.map(({handle,variant,selected}) => ({handle,variant,selected})))); }
    catch { status('Your wall works for this visit, but this browser could not save it.'); }
    document.querySelectorAll('[data-opn-count]').forEach(el => el.textContent = items.length);
  }
  function setBusy(value) {
    busy = value;
    wall?.setAttribute('aria-busy', String(value));
    render();
  }
  function lengthLabel(p, v) {
    const options = p.options.map(o => typeof o === 'string' ? o : o.name);
    if (options.length === 1 && /length|yard/i.test(options[0]) && /^\d+(\.\d+)?$/.test(v.title)) return v.title + (Number(v.title) === 1 ? ' yard' : ' yards');
    return v.title;
  }
  function render() {
    syncAddButtons();
    const sampleButton = wall?.querySelector('[data-opn-samples]');
    if (sampleButton) sampleButton.disabled = loading || busy || !items.some(i=>i.product) || sampleButton.hasAttribute('data-samples-unavailable');
    document.querySelectorAll('[data-opn-count]').forEach(el => el.textContent = items.length);
    if (!board) return;
    if (loading) { board.innerHTML = '<p class="opn-empty">Loading your fabric wall…</p>'; return; }
    board.innerHTML = items.length ? items.map((item, i) => {
      const p = item.product, v = getVariant(item), inCart = lines(item);
      const canReplace = inCart.length === 1 && simple(inCart[0]);
      const same = inCart.length === 1 && String(inCart[0].variant_id) === String(item.variant);
      const blocked = busy || !v?.available || !cart || (!!inCart.length && (!canReplace || same));
      const label = !v?.available ? (p?.variants.some(opt => opt.available) ? 'Selected length unavailable' : 'Sold out') : !inCart.length ? 'Add to Cart' : same ? 'Already in cart' : canReplace ? 'Update Cart Length' : 'Review cart';
      return `<article class="opn-swatch" data-handle="${esc(item.handle)}">
        <div class="opn-image">${p?.featured_image ? `<img src="${esc(safeImage(p.featured_image))}" alt="${esc(p.title)}">` : '<span>Image unavailable</span>'}</div>
        <div class="opn-swatch-body"><label class="opn-select"><input type="checkbox" data-opn-select ${item.selected ? 'checked' : ''} ${busy ? 'disabled' : ''}> Include</label>
        <a class="opn-fabric-title" href="${root}products/${encodeURIComponent(item.handle)}">${esc(p?.title || item.handle)}</a>
        ${p ? `<label>Length<select data-opn-length ${busy ? 'disabled' : ''}>${p.variants.map(opt => `<option value="${opt.id}" ${String(opt.id) === String(item.variant) ? 'selected' : ''} ${!opt.available ? 'disabled' : ''}>${esc(lengthLabel(p,opt))}${!opt.available ? ' — unavailable' : ''}</option>`).join('')}</select></label>` : '<p>Unable to load this fabric. Remove it or refresh to retry.</p>'}
        <strong>${v ? money(v.price) : 'Unavailable'}</strong>
        ${inCart.length ? `<small>In cart: ${inCart.map(l=>esc(l.variant_title || 'Default') + ' × ' + l.quantity).join(', ')}</small>` : ''}
        <button type="button" class="opn-primary" data-opn-cart ${blocked ? 'disabled' : ''}>${label}</button>
        <div class="opn-arrange"><button type="button" data-opn-move="-1" aria-label="Move ${esc(p?.title || 'fabric')} earlier" ${i === 0 || busy ? 'disabled' : ''}>←</button><button type="button" data-opn-move="1" aria-label="Move ${esc(p?.title || 'fabric')} later" ${i === items.length-1 || busy ? 'disabled' : ''}>→</button><button type="button" data-opn-remove ${busy ? 'disabled' : ''}>Remove</button></div></div></article>`;
    }).join('') : '<div class="opn-empty"><strong>Your next cozy combination starts here.</strong><p>Add a few fabrics below to see how their colors look together.</p></div>';
    wall.querySelector('[data-opn-total]').textContent = money(items.filter(i=>i.selected).reduce((sum,i)=>sum+(getVariant(i)?.price || 0),0));
    wall.querySelector('[data-opn-add-all]').disabled = busy || !cart || !items.some(i=>i.selected && getVariant(i)?.available);
    wall.querySelector('[data-opn-clear]').disabled = busy || !items.length;
  }
  async function refreshCart() { cart = await request(root + 'cart.js'); }
  async function refreshItems(selected) {
    let changed = false;
    const available = [], skipped = [];
    for (const item of selected) {
      const old = getVariant(item);
      item.product = await product(item.handle, true);
      const current = getVariant(item);
      if (!current?.available) {
        skipped.push(`${item.product.title} (${item.product.variants.some(v => v.available) ? 'selected length unavailable' : 'sold out'})`);
        continue;
      }
      available.push(item);
      if (old && current.price !== old.price) changed = true;
    }
    if (changed) throw new Error('A fabric price has changed. The new prices are shown; please review and click again.');
    return {available, skipped};
  }
  async function purchase(selected, allowReplace) {
    if (busy || loading) return;
    setBusy(true); status('Checking lengths and your cart…');
    try {
      const checked = await refreshItems(selected);
      selected = checked.available;
      const skippedNote = checked.skipped.length ? ` Skipped: ${checked.skipped.join('; ')}. These fabrics stay on your wall for comparison.` : '';
      if (!selected.length) { status('None of the selected lengths are available to add.' + skippedNote, true); return; }
      await refreshCart();
      const conflict = selected.find(item => lines(item).length && !(lines(item).length === 1 && simple(lines(item)[0]) && String(lines(item)[0].variant_id) === String(item.variant)));
      if (conflict) {
        const current = lines(conflict);
        if (!allowReplace || selected.length !== 1 || current.length !== 1 || !simple(current[0])) throw new Error('This fabric is already in your cart with a different length or multiple cuts. Use its Update Cart Length button, or open your cart to review it.');
        const item = conflict, old = current[0], v = getVariant(item);
        if (!window.confirm(`Replace ${old.variant_title} with ${lengthLabel(item.product,v)} of ${item.product.title}?\nNew cut price: ${money(v.price)} before discounts.`)) { status('Cart unchanged. Your wall selection is saved.'); return; }
        // Add first so a stock rejection cannot delete the customer's existing cut.
        await request(root + 'cart/add.js', {items:[{id:v.id,quantity:1}]});
        try { await request(root + 'cart/change.js', {id:old.key,quantity:0}); }
        catch { throw new Error('The new length was added, but the previous cut could not be removed. Open your cart and remove the extra cut before checkout.'); }
        await refreshCart();
        const actual = lines(item);
        if (actual.length !== 1 || String(actual[0].variant_id) !== String(v.id) || actual[0].quantity !== 1) throw new Error('Your cart changed during the update. Please open your cart to verify the fabric lengths.');
        status('Cart length updated. Your other fabrics are unchanged.');
      } else {
        const pending = selected.filter(item => !lines(item).length);
        if (!pending.length) { status('These lengths are already in your cart.' + skippedNote); return; }
        await request(root + 'cart/add.js', {items:pending.map(item => ({id:getVariant(item).id,quantity:1}))});
        await refreshCart();
        if (pending.some(item=>!lines(item).some(l=>String(l.variant_id)===String(item.variant) && l.quantity===1))) throw new Error('Some selections could not be confirmed. Please review your cart before trying again.');
        status(`${pending.length} fabric${pending.length === 1 ? '' : 's'} added to your cart.` + skippedNote);
      }
    } catch (error) {
      status(error.message + ' Check your cart before retrying if anything may have been added.',true);
    } finally {
      try { await refreshCart(); } catch { cart = null; status('Unable to refresh your cart. Open the cart or refresh this page before adding more fabrics.',true); }
      // Warehouse listens for cart:refresh to reload its cart UI after external changes.
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles:true}));
      setBusy(false);
    }
  }
  async function add(handle, preferred, openWall = false) {
    if (busy || loading) return;
    if (items.some(i=>i.handle===handle)) { status('This fabric is already on your wall.'); if (openWall) location.assign(wallURL); return; }
    if (items.length >= 6) { status('Your wall holds six fabrics. Remove one to make room.',true); return; }
    addingHandle = handle;
    setBusy(true);
    try {
      const p = await product(handle);
      const choice = p.variants.find(v=>String(v.id)===String(preferred) && v.available) || p.variants.find(v=>v.available) || p.variants[0];
      items.push({handle,variant:choice.id,selected:true,product:p}); save();
      status('Added to your fabric wall.');
      if (openWall) location.assign(wallURL);
    } catch (error) { status(error.message,true); }
    finally { addingHandle = null; setBusy(false); }
  }
  async function browse(url) {
    const id = ++browseID;
    const hint = wall.querySelector('[data-opn-browse-status]');
    hint.textContent = 'Loading fabrics…';
    try {
      const u = new URL(url, location.origin); u.searchParams.set('view','opn-fabric-results');
      const response = await fetch(u, {credentials:'same-origin'});
      if (!response.ok) throw new Error('Could not load fabrics. Please try again.');
      const html = new DOMParser().parseFromString(await response.text(),'text/html');
      const results = html.querySelector('[data-opn-results]');
      if (!results) throw new Error('Fabric results are unavailable. Please try again.');
      if (id !== browseID) return;
      wall.querySelector('[data-opn-catalog-host]').replaceChildren(results);
      syncAddButtons();
      hint.textContent = results.querySelector('.opn-catalog-card') ? '' : 'No yardage fabrics on this page. Try another search, collection, or results page.';
    } catch (error) { if (id===browseID) hint.textContent = error.message; }
  }
  document.addEventListener('click', event => {
    const addButton = event.target.closest('[data-opn-add]');
    if (addButton) { event.preventDefault(); add(addButton.dataset.opnAdd, addButton.dataset.opnVariant, addButton.hasAttribute('data-opn-open-wall')); return; }
    if (!wall) return;
    const button = event.target.closest('button,a'); if (!button || !wall.contains(button)) return;
    const item = items.find(i=>i.handle===button.closest('[data-handle]')?.dataset.handle);
    if (button.hasAttribute('data-opn-page')) { event.preventDefault(); browse(button.href); }
    if (busy) return;
    if (button.hasAttribute('data-opn-remove') && item) { items = items.filter(i=>i!==item); save(); render(); }
    if (button.hasAttribute('data-opn-move') && item) { const i = items.indexOf(item), j = i + Number(button.dataset.opnMove); if(j>=0 && j<items.length) { [items[i],items[j]]=[items[j],items[i]]; save(); render(); board.querySelectorAll('.opn-swatch')[j].querySelector('[data-opn-move]').focus(); } }
    if (button.hasAttribute('data-opn-cart') && item) purchase([item],true);
    if (button.hasAttribute('data-opn-add-all')) purchase(items.filter(i=>i.selected),false);
    if (button.hasAttribute('data-opn-clear') && window.confirm('Clear your fabric wall? Your shopping cart will stay unchanged.')) { items=[];save();render(); }
  });
  wall?.addEventListener('change', event => {
    if (busy) return;
    const el = event.target, item = items.find(i=>i.handle===el.closest('[data-handle]')?.dataset.handle);
    if (item && el.hasAttribute('data-opn-length')) { item.variant = el.value; save();render(); const select=board.querySelector(`[data-handle="${CSS.escape(item.handle)}"] [data-opn-length]`);select?.focus(); }
    if (item && el.hasAttribute('data-opn-select')) { item.selected=el.checked;save();render(); }
    if (el.hasAttribute('data-opn-layout')) board.classList.toggle('opn-board-grid',el.value==='grid');
    if (el.hasAttribute('data-opn-collection')) { wall.querySelector('[name="q"]').value=''; browse(el.value); }
  });
  wall?.querySelector('[data-opn-search]').addEventListener('submit',event=>{
    event.preventDefault(); const q = new FormData(event.target).get('q').trim();
    if (!q) { browse(wall.querySelector('[data-opn-collection]').value);return; }
    const u = new URL(root+'search',location.origin);u.searchParams.set('type','product');u.searchParams.set('q',q);u.searchParams.set('options[prefix]','last');browse(u);
  });
  const sampleDialog = wall?.querySelector('[data-opn-sample-dialog]');
  function updateSampleCount() {
    const count = sampleDialog.querySelectorAll('[data-opn-sample-choice]:checked').length;
    sampleDialog.querySelector('[data-opn-sample-count]').textContent = count > 5 ? `${count} selected. Uncheck one fabric to continue with up to five swatches.` : `${count} of 5 swatches selected.`;
    sampleDialog.querySelector('[type="submit"]').disabled = count < 1 || count > 5;
  }
  wall?.querySelector('[data-opn-samples]')?.addEventListener('click', () => {
    if (busy || loading || !sampleDialog) return;
    sampleDialog.querySelector('[data-opn-sample-options]').innerHTML = items.filter(i=>i.product).map(item => `<label class="opn-sample-choice"><input type="checkbox" data-opn-sample-choice value="${esc(item.handle)}" checked><span>${esc(item.product.title)}</span></label>`).join('');
    updateSampleCount();
    sampleDialog.showModal();
  });
  sampleDialog?.addEventListener('change', updateSampleCount);
  sampleDialog?.querySelector('[data-opn-sample-cancel]').addEventListener('click',()=>sampleDialog.close());
  sampleDialog?.querySelector('form').addEventListener('submit', event => {
    event.preventDefault();
    const chosen = Array.from(sampleDialog.querySelectorAll('[data-opn-sample-choice]:checked')).map(input=>items.find(item=>item.handle===input.value)).filter(item=>item?.product);
    if (chosen.length < 1 || chosen.length > 5) { updateSampleCount(); return; }
    const url = new URL(wall.querySelector('[data-opn-samples]').dataset.sampleUrl, location.origin);
    url.searchParams.set('opn_wall','1');
    chosen.forEach(item=>url.searchParams.append('opn_swatch',item.product.title));
    location.assign(url.href);
  });
  function fillSampleFields() {
    if (!location.pathname.endsWith('/products/' + sampleHandle)) return;
    const params = new URLSearchParams(location.search);
    if (params.get('opn_wall') !== '1') return;
    const names = params.getAll('opn_swatch');
    if (!names.length || names.length > 5 || names.some(name=>!name.trim() || name.length > 500)) return;
    const fields = Array.from({length:5},(_,i)=>document.querySelector(`input[name="properties[Swatch ${i+1}]"]`));
    if (fields.some(field=>!field)) { status('Your swatch names could not be filled in. Please enter them below or return to your fabric wall.',true); return; }
    fields.forEach((field,i)=>{
      if (!field.value && names[i]) {
        field.value = names[i];
        field.dispatchEvent(new Event('input',{bubbles:true}));
        field.dispatchEvent(new Event('change',{bubbles:true}));
      }
    });
    const note = document.createElement('div');
    note.className='opn-sample-prefill'; note.setAttribute('role','status');
    note.innerHTML=`<strong>Your Fabric Design Wall swatches are ready.</strong><p>Review the fabric names below, then use Add to cart to order your swatch pack. You can edit any name before adding.</p><a href="${wallURL}">Return to Fabric Design Wall</a>`;
    const container = fields[0].closest('.form__input-wrapper') || fields[0].parentElement;
    container.before(note);
  }
  async function init() {
    try { const stored=JSON.parse(localStorage.getItem(KEY)||'[]'); const seen=new Set(); if(Array.isArray(stored)) items=stored.filter(i=>i && typeof i.handle==='string' && !seen.has(i.handle) && seen.add(i.handle)).slice(0,6).map(i=>({handle:i.handle,variant:String(i.variant),selected:i.selected!==false})); } catch { items=[]; }
    if (!wall) {
      const tray = document.createElement('aside');tray.className='opn-wall-tray';tray.setAttribute('aria-label','Fabric wall');tray.innerHTML=`<a href="${wallURL}">Fabric Wall · <span data-opn-count>0</span></a><span data-opn-toast role="status"></span>`;document.body.append(tray);
      loading=false;render();return;
    }
    render();
    if (wall.hasAttribute('data-opn-page-wall')) browse(wall.dataset.collectionUrl);
    await Promise.all(items.map(async item=>{try{item.product=await product(item.handle);}catch{/* Keep the unavailable selection removable. */}}));
    try { await refreshCart(); } catch { status('Unable to load your cart. You can compare fabrics; refresh before adding them to your cart.',true); }
    loading=false;render();
  }
  new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.('[data-opn-add]') || node.querySelector?.('[data-opn-add]'))))) syncAddButtons();
  }).observe(document.body, {childList:true,subtree:true});
  init();
  fillSampleFields();
})();


